module.exports = __webpack_public_path__ + "img/wc.711d8c85.png";